export enum ETagType {
  ACCOUNT = 'Account',
  UserContact = 'UserContact',
}

export interface ITag {
  name: string;
  id: number;
  tag_type: ETagType;
  taggings_count: number;
}